import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button';
import {useState} from 'react'
import {Params} from './../params.jsx'
import SecondHead from './../components/SecondHead'
import CarouselBox from '../components/CarouselBox'
import {getNumberNights} from './../assets/number_nights'
import axios from 'axios'
import { Link } from "react-router-dom";



import {SERVER} from '../config.jsx'



const server = SERVER || 'http://localhost:5000'



function CheckRoom(props){

    const [arrival, setArrival] = useState(new Date());
    const [departure, setDeparture] = useState(new Date());
    const [announcement, setAnnouncement] = useState(true)
    const [rightDates, setRightDates] = useState(true)

    const onClick = (e) => {
        if(getNumberNights(arrival, departure) >= 0){
            const ax = axios.create({
            baseURL: `${server}/`,
            timeout: 5000,
            withCredentials: false
            })
              ax.get('api/user/room', {params: {
                room: props.number,
                arrival: arrival,
                departure: departure
                }})
                .then((response) => {
                    const info = response.data;
                     if(info){
                        setRightDates(true)
                        props.onClick(arrival, departure)
                     }
                     else { 
                        setAnnouncement(false) 
                        setRightDates(true)
                    }

            }) 
        }
        else setRightDates(false)
    }

    return(
        <>
        <SecondHead lang = {props.lang} link = {props.link}/>

        <div className="container mymarge">
            <div className="row bg3">
                <div className="col bg2 d-flex justify-content-center mt-3">
                   <div className="fs-3">
                   {announcement?
                      <p>{Params(props.lang).choice_date}</p>
                      :
                        <p>{Params(props.lang).sorry_reserve}</p>

                   }        
                    </div>
                    
                </div>
            </div>
            
            <div className="row">
                <div className="col bg3">           
                    <div className="row">
                        <div className="col d-flex justify-content-center">
                            
                                <Form>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="input_arr">
                                                <Form.Label className="fs-6 d-flex justify-content-center">{Params(props.lang).arrival}</Form.Label>
                                                <Form.Control
                                                type="date"
                                                name="datepic"
                                                placeholder="DateRange"
                                                value={arrival}
                                                onChange={(e) => setArrival(e.target.value)}
                                              />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="input_dep">
                                                <Form.Label className="fs-6 d-flex justify-content-center">{Params(props.lang).departure}</Form.Label>
                                                <Form.Control
                                                type="date"
                                                name="datepic"
                                                placeholder="DateRange"
                                                value={departure}
                                                onChange={(e) => setDeparture(e.target.value)}
                                              />
                                    
                                            </div>   
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col d-flex justify-content-center mt-1">
                                            <div className="fs-6 text-danger">
                                             {!rightDates?
                                                <p>{Params(props.lang).wrong_dates}</p>
                                                 :
                                                <p></p>

                                                }        
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="d-flex justify-content-center align-items-center mb-4">                                
                                            <div className=" fs-2">
                                                <Button variant="secondary" onClick = {onClick}>{Params(props.lang).book}</Button>
                                            </div>
                                        </div>
                                    </div>
                                </Form>


                        </div>
                    </div>
                    
                </div>
            </div>

            <div className="row">
                <div className="col-md-8 bg3 d-flex justify-content-center align-items-center">

                        <div className=" d-flex flex-column justify-content-center align-items-center w-100 h-100">


            
                            <div className="owl-carousel owl-theme">
                                <CarouselBox img = {props.img}/>
                            </div>

                        </div>

                </div>
                <div className="col-md-4 bg3 d-flex flex-column justify-content-center">
                   <div className="fs-5 my-first-letter bg1 mx-3 mb-4 desc-room px-3 pt-3 pb-3">
                        <p className="fs-2 text-center text-danger ">{Params(props.lang).your_choice}</p>
                        {props.description_room(props.lang)}
                    </div>
                </div>

            </div>
            <div className="row bg3 mb-2">
                <div className="col-md-6 offset-md-3">
                    <div className="text-center w-100">

                        <Link to="/rooms" className="btn btn-outline-success fs-5 bg5 mt-3 mb-3" role="button">
                          {Params(props.lang).another_choice}
                        </Link>
                    </div>
                </div>

            </div>
        </div>
        </>

        )

}

export default CheckRoom;